import dayjs from 'dayjs';
import { ContactEmploymentMeta } from '/@/modules/contact/models/meta/ContactEmploymentMeta';
import { DateFormat } from '/@/modules/core/app/constants/date.constants';
import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class ContactEmployment extends BaseEntityModel {
  id?: number;
  contactId?: number;
  jobTitle?: string;
  meta?: ContactEmploymentMeta;
  employer?: string;
  startDate?: string;
  endDate?: string;

  constructor(model: Partial<ContactEmployment> = {}) {
    super(model);

    this.id = model.id;
    this.contactId = model.contactId;
    this.jobTitle = model.jobTitle;
    this.employer = model.employer;
    this.startDate = model.startDate;
    this.endDate = model.endDate;
    this.meta = new ContactEmploymentMeta(model.meta);
  }

  get isoFormattedStartDate(): string {
    return dayjs(this.startDate).format(DateFormat.ISO);
  }

  get isoFormattedEndDate(): string {
    return dayjs(this.endDate).format(DateFormat.ISO);
  }
}
